export default "__VITE_ASSET__BLSfboI___"